import { steps } from "@/mocks/homeData";

export default function HowItWorksSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase mb-2 block">
            Notre fonctionnement
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 font-heading tracking-wide">
            Comment ça marche
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-base md:text-lg">
            De la prise de contact à l'intervention, chaque étape est pensée pour
            vous offrir transparence et clarté.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative text-center">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-1/2 w-full h-px bg-white/20" />
              )}

              <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/10 border-2 border-white/20 text-primary-500 mb-5 z-10">
                <i className={`${step.icon} w-8 h-8 flex items-center justify-center text-2xl`} />
                <span className="absolute -top-2 -right-2 w-8 h-8 flex items-center justify-center bg-primary-500 text-white text-xs font-bold rounded-full">
                  {step.number}
                </span>
              </div>

              <h3 className="text-lg font-semibold text-white mb-2 font-heading tracking-wide">
                {step.title}
              </h3>
              <p className="text-sm text-white/70 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}